"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mauritaniaGeoJson = {
    type: "FeatureCollection",
    features: [
        {
            type: "Feature",
            geometry: {
                type: "Polygon",
                coordinates: [
                    [
                        [-7.988619980929679, 19.725184825810683],
                        [-9.147255254836304, 17.28753411201545],
                        [-9.149707392982139, 17.28251320426304],
                        [-8.599202379242376, 17.35155068585868],
                        [-8.289006903794359, 17.0226812280758],
                        [-8.750008875211176, 16.531887495277687],
                        [-8.893458956742473, 16.3925573051483],
                        [-8.86893757528413, 16.322264596614556],
                        [-9.067560765096696, 16.061177393489217],
                        [-8.96947523926333, 15.857830629516595],
                        [-8.959666686679993, 15.539002987238538],
                        [-9.00257910423209, 15.495070044404947],
                        [-5.510734384564294, 15.495070044404947],
                        [-5.352571474157992, 16.312222781109735],
                        [-5.364832164887163, 16.33481686599558],
                        [-5.605141703178909, 16.496741141010816],
                        [-5.622306670199746, 16.52812181446338],
                        [-5.948441043595686, 19.49547829613791],
                        [-6.0649176055228065, 20.495894165805673],
                        [-6.371434873752072, 23.124339374192502],
                        [-6.378791288189575, 23.106766197059066],
                        [-7.988619980929679, 19.725184825810683],
                    ],
                ],
            },
            properties: {
                abbreviation: "HC",
                name: "Hodh ech Chargui",
                country: "Mauritania",
                region: "Hodh ech Chargui",
                type: "Wilayat",
            },
        },
        {
            type: "Feature",
            geometry: {
                type: "Polygon",
                coordinates: [
                    [
                        [-9.149707392982139, 17.28251320426304],
                        [-9.723507719107324, 17.557407903707507],
                        [-10.332864048347105, 17.518495868626324],
                        [-11.079540113753596, 17.72309785953705],
                        [-11.093026873555683, 17.657826058755713],
                        [-11.058696939514007, 17.524772003316837],
                        [-10.991263140503568, 17.391717947877964],
                        [-10.981454587920231, 17.28376843120114],
                        [-11.01088024567024, 17.160756191267087],
                        [-10.980228518847314, 17.10050529823816],
                        [-10.996167416795235, 16.980003512180314],
                        [-10.99003707143065, 16.815568783288874],
                        [-10.896855821888954, 16.74025516700272],
                        [-10.839230575461851, 16.614732473192458],
                        [-10.705589046513893, 16.603435430749535],
                        [-10.768118569232662, 16.50929341039184],
                        [-10.872334440430613, 16.465360467558252],
                        [-10.809804917711842, 16.422682751662762],
                        [-10.845360920826437, 16.302180965604915],
                        [-10.838004506388934, 16.248206207266502],
                        [-10.76076215479516, 16.185444860361372],
                        [-10.777927121815999, 16.04485944329388],
                        [-10.666354836180545, 15.938165153555161],
                        [-10.58543427736802, 15.42854301668551],
                        [-10.53516544537842, 15.441095286066535],
                        [-10.308342666888763, 15.434819151376022],
                        [-10.131788720388705, 15.372057804470892],
                        [-9.951556566669897, 15.380844393037611],
                        [-9.835080004742776, 15.372057804470892],
                        [-9.672012818044808, 15.431053470561714],
                        [-9.423120796242642, 15.441095286066535],
                        [-9.452546453992653, 15.559086618248179],
                        [-9.376530171471796, 15.68586453899654],
                        [-9.33239168484678, 15.687119765934643],
                        [-9.34955665186762, 15.495070044404947],
                        [-9.00257910423209, 15.495070044404947],
                        [-8.959666686679993, 15.539002987238538],
                        [-8.96947523926333, 15.857830629516595],
                        [-9.067560765096696, 16.061177393489217],
                        [-8.86893757528413, 16.322264596614556],
                        [-8.893458956742473, 16.3925573051483],
                        [-8.750008875211176, 16.531887495277687],
                        [-8.289006903794359, 17.0226812280758],
                        [-8.599202379242376, 17.35155068585868],
                        [-9.149707392982139, 17.28251320426304],
                    ],
                ],
            },
            properties: {
                abbreviation: "HG",
                name: "Hodh el Gharbi",
                country: "Mauritania",
                region: "Hodh el Gharbi",
                type: "Wilayat",
            },
        },
        {
            type: "Feature",
            geometry: {
                type: "Polygon",
                coordinates: [
                    [
                        [-10.58543427736802, 15.42854301668551],
                        [-10.666354836180545, 15.938165153555161],
                        [-10.777927121815999, 16.04485944329388],
                        [-10.76076215479516, 16.185444860361372],
                        [-10.838004506388934, 16.248206207266502],
                        [-10.845360920826437, 16.302180965604915],
                        [-10.809804917711842, 16.422682751662762],
                        [-10.872334440430613, 16.465360467558252],
                        [-10.768118569232662, 16.50929341039184],
                        [-10.705589046513893, 16.603435430749535],
                        [-10.839230575461851, 16.614732473192458],
                        [-10.896855821888954, 16.74025516700272],
                        [-10.99003707143065, 16.815568783288874],
                        [-10.996167416795235, 16.980003512180314],
                        [-10.980228518847314, 17.10050529823816],
                        [-11.01088024567024, 17.160756191267087],
                        [-10.981454587920231, 17.28376843120114],
                        [-10.991263140503568, 17.391717947877964],
                        [-11.058696939514007, 17.524772003316837],
                        [-11.093026873555683, 17.657826058755713],
                        [-11.079540113753596, 17.72309785953705],
                        [-10.970419966263979, 18.31054406656906],
                        [-11.104061495211937, 18.26284544292116],
                        [-11.193564537534883, 18.186276599696903],
                        [-11.169043156076542, 18.161172060934852],
                        [-11.21195557362864, 18.09715548709162],
                        [-11.323527859264093, 18.064519586700953],
                        [-11.485368976889145, 18.07832708302008],
                        [-11.547898499607914, 18.050712090381825],
                        [-11.59571519345168, 17.95531484308603],
                        [-11.506212151128734, 17.814729426018538],
                        [-11.529507463514157, 17.817239879894743],
                        [-11.425291592316208, 17.67539923588915],
                        [-11.421613385097457, 17.602596073479198],
                        [-11.514794634639154, 17.557407903707507],
                        [-11.468204009868305, 17.509709280059607],
                        [-11.508664289274568, 17.493391329864274],
                        [-11.527055325368323, 17.17707414146242],
                        [-11.569967742920422, 17.123099383124007],
                        [-11.752652034785065, 17.139417333319344],
                        [-11.910814945191365, 17.086697801919033],
                        [-12.21365400620188, 17.18711595696724],
                        [-12.309287393889411, 17.27498184263442],
                        [-12.348521604222757, 17.227283218986525],
                        [-12.491971685754052, 17.168287552895702],
                        [-12.517719136285312, 17.120588929247802],
                        [-12.72737694775413, 17.046530539899752],
                        [-12.799715023056237, 16.96745124279929],
                        [-12.82301033544166, 16.85824649918436],
                        [-12.800941092129154, 16.82310014491749],
                        [-12.83159281895208, 16.67372813928328],
                        [-12.778871848816646, 16.642347465830717],
                        [-12.735959431264549, 16.553226353225433],
                        [-12.761706881795806, 16.459084332867736],
                        [-12.657491010597857, 16.485444098567893],
                        [-12.429442163035283, 16.442766382672403],
                        [-12.412277196014443, 16.30469141948112],
                        [-12.426990024889449, 16.205528491371012],
                        [-12.31296560110816, 16.25699279583322],
                        [-12.240627525806055, 16.220591214628246],
                        [-12.2222364897123, 16.12142828651814],
                        [-12.098403513347677, 16.10636556326091],
                        [-12.011352609170565, 16.052390804922496],
                        [-12.00522226380598, 15.939420380493264],
                        [-11.935336326649708, 15.901763572350186],
                        [-11.834798662670508, 15.909294933978803],
                        [-11.79556445233716, 15.973311507822034],
                        [-11.82131190286842, 16.03983853554147],
                        [-11.677861821337123, 16.031051946974753],
                        [-11.607975884180851, 15.98586377720306],
                        [-11.500081805764149, 15.969545827007726],
                        [-11.561385259410002, 15.904274026226393],
                        [-11.612880160472518, 15.767454289973209],
                        [-11.650888301732948, 15.727287027953926],
                        [-11.702383202795463, 15.537747760300434],
                        [-11.644757956368363, 15.52645071785751],
                        [-11.524603187222489, 15.600509107205564],
                        [-11.527055325368323, 15.643186823101052],
                        [-11.409352694368287, 15.60301956108177],
                        [-11.297780408732834, 15.451137101571355],
                        [-11.045210179711919, 15.270384422484582],
                        [-10.915246857982709, 15.102184012778835],
                        [-10.828195953805597, 15.287957599618018],
                        [-10.747275394993071, 15.340677131018328],
                        [-10.736240773336817, 15.4235221089331],
                        [-10.58543427736802, 15.42854301668551],
                    ],
                ],
            },
            properties: {
                abbreviation: "AS",
                name: "Assaba",
                country: "Mauritania",
                region: "Assaba",
                type: "Wilayat",
            },
        },
        {
            type: "Feature",
            geometry: {
                type: "Polygon",
                coordinates: [
                    [
                        [-12.00522226380598, 15.939420380493264],
                        [-12.011352609170565, 16.052390804922496],
                        [-12.098403513347677, 16.10636556326091],
                        [-12.2222364897123, 16.12142828651814],
                        [-12.240627525806055, 16.220591214628246],
                        [-12.31296560110816, 16.25699279583322],
                        [-12.426990024889449, 16.205528491371012],
                        [-12.412277196014443, 16.30469141948112],
                        [-12.429442163035283, 16.442766382672403],
                        [-12.657491010597857, 16.485444098567893],
                        [-12.761706881795806, 16.459084332867736],
                        [-12.735959431264549, 16.553226353225433],
                        [-12.778871848816646, 16.642347465830717],
                        [-12.83159281895208, 16.67372813928328],
                        [-12.800941092129154, 16.82310014491749],
                        [-12.82301033544166, 16.85824649918436],
                        [-12.93090441385836, 16.61598770013056],
                        [-13.109910498504252, 16.57582043811128],
                        [-13.15772719234802, 16.520590452834764],
                        [-13.181022504733443, 16.413896163096044],
                        [-13.589303506014826, 16.307201873357325],
                        [-13.632215923566923, 16.289628696223886],
                        [-13.64938089058776, 16.205528491371012],
                        [-13.719266827744034, 16.15908509466122],
                        [-13.676354410191937, 16.10636556326091],
                        [-13.485087634816875, 16.15531941384691],
                        [-13.492444049254377, 16.088792386127473],
                        [-13.439723079118943, 16.1025998824466],
                        [-13.314664033681403, 15.92310243029793],
                        [-13.287690514077227, 15.77749610547803],
                        [-13.228839198577209, 15.69590635450136],
                        [-13.237421682087628, 15.623103192091412],
                        [-13.122171189233423, 15.60301956108177],
                        [-13.09029339333758, 15.497580498281152],
                        [-12.964008278827123, 15.510132767662178],
                        [-12.90638303240002, 15.353229400399353],
                        [-12.834044957097914, 15.26912919554648],
                        [-12.85611420041042, 15.221430571898582],
                        [-12.78132398696248, 15.207623075579452],
                        [-12.746994052920803, 15.131054232355195],
                        [-12.705307704441623, 15.270384422484582],
                        [-12.587605073441583, 15.473731186457202],
                        [-12.494423823899886, 15.567873206814896],
                        [-12.463772097076962, 15.658249546358283],
                        [-12.293348495941489, 15.807621551992492],
                        [-12.236949318587303, 15.880424714402443],
                        [-12.141315930899772, 15.885445622154853],
                        [-12.00522226380598, 15.939420380493264],
                    ],
                ],
            },
            properties: {
                abbreviation: "GO",
                name: "Gorgol",
                country: "Mauritania",
                region: "Gorgol",
                type: "Wilayat",
            },
        },
        {
            type: "Feature",
            geometry: {
                type: "Polygon",
                coordinates: [
                    [
                        [-13.719266827744034, 16.15908509466122],
                        [-13.64938089058776, 16.205528491371012],
                        [-13.632215923566923, 16.289628696223886],
                        [-13.589303506014826, 16.307201873357325],
                        [-13.181022504733443, 16.413896163096044],
                        [-13.15772719234802, 16.520590452834764],
                        [-13.109910498504252, 16.57582043811128],
                        [-12.93090441385836, 16.61598770013056],
                        [-12.82301033544166, 16.85824649918436],
                        [-12.799715023056237, 16.96745124279929],
                        [-12.72737694775413, 17.046530539899752],
                        [-12.517719136285312, 17.120588929247802],
                        [-12.491971685754052, 17.168287552895702],
                        [-12.348521604222757, 17.227283218986525],
                        [-12.309287393889411, 17.27498184263442],
                        [-12.40982505786861, 17.355316366672987],
                        [-12.544692655889488, 17.49213610292617],
                        [-12.506684514629058, 17.997992558981515],
                        [-12.479710995024883, 18.274142485364088],
                        [-12.66852563225411, 18.55656854643717],
                        [-13.733979656619038, 17.799666702761307],
                        [-13.959576366035778, 17.602596073479198],
                        [-14.320040673473395, 17.087953028857136],
                        [-14.570158764348475, 16.908455576708466],
                        [-14.620427596338075, 16.855736045308156],
                        [-14.834989684098561, 16.75155220944564],
                        [-14.949014107879847, 16.669962458468973],
                        [-14.930623071786092, 16.64360269276882],
                        [-14.597132283952652, 16.628539969511586],
                        [-14.483107860171364, 16.633560877264],
                        [-14.407091577650506, 16.661175869902255],
                        [-14.343335985858818, 16.636071331140204],
                        [-14.015975543389963, 16.356155723943324],
                        [-13.977967402129535, 16.33858254680989],
                        [-13.96325457325453, 16.230633030133067],
                        [-13.908081464973261, 16.20929417218532],
                        [-13.811222008212813, 16.12142828651814],
                        [-13.746240347348209, 16.181679179547064],
                        [-13.719266827744034, 16.15908509466122],
                    ],
                ],
            },
            properties: {
                abbreviation: "BR",
                name: "Brakna",
                country: "Mauritania",
                region: "Brakna",
                type: "Wilayat",
            },
        },
        {
            type: "Feature",
            geometry: {
                type: "Polygon",
                coordinates: [
                    [
                        [-12.66852563225411, 18.55656854643717],
                        [-13.244778096525131, 19.000918882525486],
                        [-14.22195514764003, 18.999663655587383],
                        [-14.262415427046292, 18.999663655587383],
                        [-16.210639183911507, 18.995897974773076],
                        [-16.16650069728649, 18.84401551526266],
                        [-16.172631042651076, 18.79380643773856],
                        [-16.132170763244815, 18.628116481909018],
                        [-16.069641240526046, 18.48376538402722],
                        [-16.061058757015626, 18.390878590607628],
                        [-15.781515008390535, 18.393389044483833],
                        [-15.781515008390535, 17.886277361490386],
                        [-16.031633099265616, 17.88753258842849],
                        [-16.050024135359372, 17.66661264732243],
                        [-16.07944979310938, 17.54485563432648],
                        [-16.172631042651076, 17.262429573253396],
                        [-16.278072982921945, 17.04150963214734],
                        [-16.343054643786548, 16.942346704037234],
                        [-16.45953120571367, 16.644857919706922],
                        [-16.466887620151173, 16.492975460196508],
                        [-16.53922569545328, 16.26703461133804],
                        [-16.526965004724108, 15.978332415574444],
                        [-16.541677833599113, 15.808876778930594],
                        [-16.509800037703272, 15.901763572350186],
                        [-16.507347899557438, 16.010968315965112],
                        [-16.465661551078256, 16.17414781791845],
                        [-16.38106278504698, 16.2469509803284],
                        [-16.32711574583863, 16.47414705612497],
                        [-16.251099463317768, 16.52812181446338],
                        [-16.132170763244815, 16.554481580163536],
                        [-16.053702342578124, 16.495485914072713],
                        [-15.813392804286378, 16.51431431814425],
                        [-15.671168791827998, 16.481678417753585],
                        [-15.609865338182146, 16.521845679772866],
                        [-15.551014022682127, 16.515569545082354],
                        [-15.448024220557093, 16.579586118925587],
                        [-15.427181046317504, 16.553226353225433],
                        [-15.23223606372369, 16.56703384954456],
                        [-15.092464189411144, 16.599669749935227],
                        [-14.97353548933819, 16.691301316416716],
                        [-14.949014107879847, 16.672472912345178],
                        [-14.834989684098561, 16.75155220944564],
                        [-14.620427596338075, 16.855736045308156],
                        [-14.570158764348475, 16.908455576708466],
                        [-14.320040673473395, 17.087953028857136],
                        [-13.959576366035778, 17.602596073479198],
                        [-13.733979656619038, 17.799666702761307],
                        [-12.66852563225411, 18.55656854643717],
                    ],
                ],
            },
            properties: {
                abbreviation: "TR",
                name: "Trarza",
                country: "Mauritania",
                region: "Trarza",
                type: "Wilayat",
            },
        },
        {
            type: "Feature",
            geometry: {
                type: "Polygon",
                coordinates: [
                    [
                        [-14.22195514764003, 18.999663655587383],
                        [-13.244778096525131, 19.000918882525486],
                        [-12.66852563225411, 18.55656854643717],
                        [-12.341165189785254, 18.899245500539177],
                        [-11.891197840024692, 19.179161107736057],
                        [-11.677861821337123, 19.319746524803545],
                        [-11.449812973774549, 19.203010419560005],
                        [-11.422839454170374, 19.40886763740883],
                        [-11.034175558055665, 19.711377329491555],
                        [-7.988619980929679, 19.725184825810683],
                        [-6.378791288189575, 23.106766197059066],
                        [-6.371434873752072, 23.124339374192502],
                        [-6.430286189252092, 23.632706284124055],
                        [-6.506302471772949, 24.270361568680173],
                        [-6.506302471772949, 24.275382476432583],
                        [-10.787735674399336, 21.52015934729739],
                        [-12.377947261972766, 21.35070371065354],
                        [-13.03144207783756, 21.58292069420252],
                        [-13.015503179889638, 21.333130533520105],
                        [-14.295519292015054, 21.333130533520105],
                        [-14.172912384723347, 21.144846492804717],
                        [-14.154521348629592, 21.11848672710456],
                        [-14.219503009494195, 19.428951268418473],
                        [-14.22195514764003, 18.999663655587383],
                    ],
                ],
            },
            properties: {
                abbreviation: "AD",
                name: "Adrar",
                country: "Mauritania",
                region: "Adrar",
                type: "Wilayat",
            },
        },
        {
            type: "Feature",
            geometry: {
                type: "MultiPolygon",
                coordinates: [
                    [
                        [
                            [-16.336924298421962, 19.855728427373354],
                            [-16.40558416650532, 19.82183730004458],
                            [-16.46320941293242, 19.6850175637914],
                            [-16.432557686109494, 19.600917358938528],
                            [-16.36757602524489, 19.721419144996375],
                            [-16.336924298421962, 19.855728427373354],
                        ],
                    ],
                    [
                        [
                            [-14.172912384723347, 21.144846492804717],
                            [-14.295519292015054, 21.333130533520105],
                            [-16.95976738746383, 21.333130533520105],
                            [-17.005131943161764, 21.141080811990406],
                            [-17.04804436071386, 21.02685516062307],
                            [-17.08114822568262, 20.873717474174555],
                            [-17.05662684422428, 20.767023184435836],
                            [-17.005131943161764, 20.932713140265378],
                            [-17.01616656481802, 21.03062084143738],
                            [-16.918081038984653, 21.159909216061948],
                            [-16.87271648328672, 21.065767195704254],
                            [-16.774630957453354, 20.937734048017788],
                            [-16.66428474089082, 20.670370710201937],
                            [-16.541677833599113, 20.559910739648906],
                            [-16.529417142869942, 20.73940819179758],
                            [-16.428879478890742, 20.64401094450178],
                            [-16.295237949942784, 20.33020420997613],
                            [-16.237612703515683, 20.29003694795685],
                            [-16.199604562255253, 20.214723331670694],
                            [-16.260908015901105, 20.13564403457023],
                            [-16.21431739113026, 20.03397065258392],
                            [-16.29769008808862, 19.922255455092788],
                            [-16.26703836126569, 19.913468866526074],
                            [-16.233934496296932, 19.792967080468223],
                            [-16.466887620151173, 19.464097622685344],
                            [-16.35041105822405, 19.545687373662012],
                            [-16.392097406703233, 19.464097622685344],
                            [-16.306272571599038, 19.543176919785807],
                            [-16.325889676765712, 19.455311034118626],
                            [-16.282977259213613, 19.49547829613791],
                            [-15.577987542286301, 20.738152964859474],
                            [-15.839140254817636, 21.149867400557127],
                            [-14.172912384723347, 21.144846492804717],
                        ],
                    ],
                ],
            },
            properties: {
                abbreviation: "DN",
                name: "Dakhlet Nouadhibou",
                country: "Mauritania",
                region: "Dakhlet Nouadhibou",
                type: "Wilayat",
            },
        },
        {
            type: "Feature",
            geometry: {
                type: "Polygon",
                coordinates: [
                    [
                        [-9.149707392982139, 17.28251320426304],
                        [-9.147255254836304, 17.28753411201545],
                        [-7.988619980929679, 19.725184825810683],
                        [-11.034175558055665, 19.711377329491555],
                        [-11.422839454170374, 19.40886763740883],
                        [-11.449812973774549, 19.203010419560005],
                        [-11.677861821337123, 19.319746524803545],
                        [-11.891197840024692, 19.179161107736057],
                        [-12.341165189785254, 18.899245500539177],
                        [-12.66852563225411, 18.55656854643717],
                        [-12.479710995024883, 18.274142485364088],
                        [-12.506684514629058, 17.997992558981515],
                        [-12.544692655889488, 17.49213610292617],
                        [-12.40982505786861, 17.355316366672987],
                        [-12.309287393889411, 17.27498184263442],
                        [-12.21365400620188, 17.18711595696724],
                        [-11.910814945191365, 17.086697801919033],
                        [-11.752652034785065, 17.139417333319344],
                        [-11.569967742920422, 17.123099383124007],
                        [-11.527055325368323, 17.17707414146242],
                        [-11.508664289274568, 17.493391329864274],
                        [-11.468204009868305, 17.509709280059607],
                        [-11.514794634639154, 17.557407903707507],
                        [-11.421613385097457, 17.602596073479198],
                        [-11.425291592316208, 17.67539923588915],
                        [-11.529507463514157, 17.817239879894743],
                        [-11.506212151128734, 17.814729426018538],
                        [-11.59571519345168, 17.95531484308603],
                        [-11.547898499607914, 18.050712090381825],
                        [-11.485368976889145, 18.07832708302008],
                        [-11.323527859264093, 18.064519586700953],
                        [-11.21195557362864, 18.09715548709162],
                        [-11.169043156076542, 18.161172060934852],
                        [-11.193564537534883, 18.186276599696903],
                        [-11.104061495211937, 18.26284544292116],
                        [-10.970419966263979, 18.31054406656906],
                        [-11.079540113753596, 17.72309785953705],
                        [-10.332864048347105, 17.518495868626324],
                        [-9.723507719107324, 17.557407903707507],
                        [-9.149707392982139, 17.28251320426304],
                    ],
                ],
            },
            properties: {
                abbreviation: "TG",
                name: "Tagant",
                country: "Mauritania",
                region: "Tagant",
                type: "Wilayat",
            },
        },
        {
            type: "Feature",
            geometry: {
                type: "Polygon",
                coordinates: [
                    [
                        [-12.00522226380598, 15.939420380493264],
                        [-12.141315930899772, 15.885445622154853],
                        [-12.236949318587303, 15.880424714402443],
                        [-12.293348495941489, 15.807621551992492],
                        [-12.463772097076962, 15.658249546358283],
                        [-12.494423823899886, 15.567873206814896],
                        [-12.587605073441583, 15.473731186457202],
                        [-12.705307704441623, 15.270384422484582],
                        [-12.746994052920803, 15.131054232355195],
                        [-12.690594875566617, 15.092142197274015],
                        [-12.632969629139517, 15.105949693593143],
                        [-12.471128511514463, 14.99800017691632],
                        [-12.44783319912904, 14.918920879815856],
                        [-12.382851538264434, 14.846117717405907],
                        [-12.224688627858132, 14.763272739491136],
                        [-12.138863792753938, 14.784611597438879],
                        [-12.070203924670583, 14.734402519914775],
                        [-11.973344467910135, 14.779590689686469],
                        [-11.82131190286842, 14.900092475744318],
                        [-11.813955488430917, 15.028125623430782],
                        [-11.860546113201766, 15.048209254440424],
                        [-11.845833284326762, 15.180008082941196],
                        [-11.726904584253806, 15.541513441114743],
                        [-11.702383202795463, 15.537747760300434],
                        [-11.650888301732948, 15.727287027953926],
                        [-11.612880160472518, 15.767454289973209],
                        [-11.561385259410002, 15.904274026226393],
                        [-11.500081805764149, 15.969545827007726],
                        [-11.607975884180851, 15.98586377720306],
                        [-11.677861821337123, 16.031051946974753],
                        [-11.82131190286842, 16.03983853554147],
                        [-11.79556445233716, 15.973311507822034],
                        [-11.834798662670508, 15.909294933978803],
                        [-11.935336326649708, 15.901763572350186],
                        [-12.00522226380598, 15.939420380493264],
                    ],
                ],
            },
            properties: {
                abbreviation: "GD",
                name: "Guidimaka",
                country: "Mauritania",
                region: "Guidimaka",
                type: "Wilayat",
            },
        },
        {
            type: "Feature",
            geometry: {
                type: "Polygon",
                coordinates: [
                    [
                        [-13.03144207783756, 21.58292069420252],
                        [-12.377947261972766, 21.35070371065354],
                        [-10.787735674399336, 21.52015934729739],
                        [-6.506302471772949, 24.275382476432583],
                        [-6.593353375950061, 24.993372285027263],
                        [-4.821683565584905, 24.994627511965366],
                        [-5.51686472992888, 25.422659897858352],
                        [-8.682575076200736, 27.285416674002597],
                        [-8.681349007127821, 26.013871785704673],
                        [-8.707096457659079, 25.99504338163313],
                        [-12.015030816389316, 25.99504338163313],
                        [-12.015030816389316, 23.49463132093277],
                        [-12.033421852483071, 23.444422243408667],
                        [-12.135185585535188, 23.419317704646613],
                        [-12.353425880514425, 23.322665230412714],
                        [-12.619482869337428, 23.27120092595051],
                        [-13.015503179889638, 23.017645084453783],
                        [-13.120945120160506, 22.883335802076807],
                        [-13.16508360678552, 22.752792200514136],
                        [-13.092745531483414, 22.495470678203105],
                        [-13.03144207783756, 21.58292069420252],
                    ],
                ],
            },
            properties: {
                abbreviation: "TZ",
                name: "Tiris Zemmour",
                country: "Mauritania",
                region: "Tiris Zemmour",
                type: "Wilayat",
            },
        },
        {
            type: "Feature",
            geometry: {
                type: "Polygon",
                coordinates: [
                    [
                        [-16.210639183911507, 18.995897974773076],
                        [-14.262415427046292, 18.999663655587383],
                        [-14.22195514764003, 18.999663655587383],
                        [-14.219503009494195, 19.428951268418473],
                        [-14.154521348629592, 21.11848672710456],
                        [-14.172912384723347, 21.144846492804717],
                        [-15.839140254817636, 21.149867400557127],
                        [-15.577987542286301, 20.738152964859474],
                        [-16.282977259213613, 19.49547829613791],
                        [-16.325889676765712, 19.455311034118626],
                        [-16.408036304651155, 19.388784006399188],
                        [-16.52206072843244, 19.396315368027803],
                        [-16.466887620151173, 19.25949563177462],
                        [-16.368802094317807, 19.221838823631543],
                        [-16.281751190140696, 19.130207257150055],
                        [-16.210639183911507, 18.995897974773076],
                    ],
                ],
            },
            properties: {
                abbreviation: "IN",
                name: "Inchiri",
                country: "Mauritania",
                region: "Inchiri",
                type: "Wilayat",
            },
        },
        {
            type: "Feature",
            geometry: {
                type: "Polygon",
                coordinates: [
                    [
                        [-16.031633099265616, 17.88753258842849],
                        [-15.781515008390535, 17.886277361490386],
                        [-15.781515008390535, 18.393389044483833],
                        [-16.061058757015626, 18.390878590607628],
                        [-16.024276684828113, 17.96033575083844],
                        [-16.031633099265616, 17.88753258842849],
                    ],
                ],
            },
            properties: {
                abbreviation: "NO",
                name: "Nouakchott",
                country: "Mauritania",
                region: "Nouakchott",
                type: "Wilayat",
            },
        },
    ],
};
exports.default = mauritaniaGeoJson;
